import Bet99PickEm from './Bet99PickEm';

const Index = () => {
  return <Bet99PickEm />;
};

export default Index;
